<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { ReviewProjectInDb, ReviewProjectInDbDetail } from '@/api';
import ReviewProjectSubPage from '@/components/reviewProject/ReviewProjectSubPage.vue';
import ReviewProjectSettings from '@/components/reviewProject/ReviewProjectSettings.vue';

const route = useRoute();
const projectUid = computed(() => route.params.uid as string);
</script>

<template>
  <review-project-sub-page v-slot="{ project, patch }" :project-uid="projectUid" title="Settings">
    <ReviewProjectSettings
      :project="project as ReviewProjectInDbDetail"
      @updated="patch as (project: ReviewProjectInDb) => void"
    />
  </review-project-sub-page>
</template>
